import { render, staticRenderFns } from "./2.vue?vue&type=template&id=d16d4cd6&scoped=true"
import script from "./2.vue?vue&type=script&lang=js"
export * from "./2.vue?vue&type=script&lang=js"
import style0 from "./2.vue?vue&type=style&index=0&id=d16d4cd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16d4cd6",
  null
  
)

export default component.exports